import { render, staticRenderFns } from "./RepresentativePlacements.vue?vue&type=template&id=43de2ed4&"
import script from "./RepresentativePlacements.vue?vue&type=script&lang=js&"
export * from "./RepresentativePlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports